import React from 'react'
import { FormatDateOptions, useIntl } from 'react-intl'
import { twMerge } from 'tailwind-merge'

import { useAccount } from 'msp-integrations'
import { CustomLinkComponent } from 'msp-components'

import * as S from './AccountOverviewOrderDetails.styles'
import * as T from './AccountOverviewOrderDetails.types'

const MAX_IMAGES_TO_DISPLAY = 4

const AccountOverviewOrderDetails = ({
  order,
  className = '',
  maxProductImagesToDisplay = MAX_IMAGES_TO_DISPLAY
}: T.AccountOverviewOrderDetailsProps) => {
  const { formatDate } = useIntl()
  const {
    orders: { productFallbackImage, convertToOrderModel }
  } = useAccount()
  const orderModel = convertToOrderModel(order)
  const dateFormattingOpts = {
    year: 'numeric',
    day: '2-digit',
    month: '2-digit'
  } as FormatDateOptions
  const handleImageNotFound = (el: HTMLImageElement) => {
    if (el.src !== productFallbackImage) {
      el.src = productFallbackImage
    }
  }
  const productImages = orderModel.getProductImages()
  const hasTooManyProducts =
    orderModel.totalProducts > maxProductImagesToDisplay

  if (hasTooManyProducts) {
    productImages.splice(maxProductImagesToDisplay)
  }

  return (
    <CustomLinkComponent
      key={`order-${orderModel.orderNo}`}
      href={`/account/orders/${orderModel.orderNo}`}
      className={twMerge(S.MainWrapper, className)}
      uppercase={false}
      inline
    >
      <div className={S.OrderContentWrapper}>
        <div className={S.OrderLeftColWrapper}>
          <div className={S.OrderDateContent}>
            {formatDate(new Date(orderModel.creationDate), dateFormattingOpts)}
          </div>
          <div className={S.OrderNoContent}>#{orderModel.orderNo}</div>
        </div>
        <div className={S.OrderRightColWrapper}>
          {productImages.length > 0 &&
            productImages.map((image, index) => (
              <div
                key={`product-img-${image.productId}-${index}`}
                className={S.OrderProductsImageWrapper}
              >
                <img
                  alt={image.alt}
                  src={image.src}
                  onError={(ev) =>
                    handleImageNotFound(ev.target as HTMLImageElement)
                  }
                  className={S.OrderProductImage}
                />
                {hasTooManyProducts &&
                  index + 1 === maxProductImagesToDisplay && (
                    <div className={S.OrderProductImageOverlayInfo}>
                      +
                      {1 + orderModel.totalProducts - maxProductImagesToDisplay}
                    </div>
                  )}
              </div>
            ))}
        </div>
      </div>
    </CustomLinkComponent>
  )
}

export default AccountOverviewOrderDetails
